/** Screen-level density options for Display Settings. Default is what each screen is designed for. */
export const DISPLAY_DENSITIES = ['compact', 'default', 'roomy'] as const;

export type DisplayDensity = (typeof DISPLAY_DENSITIES)[number];

export const DISPLAY_DENSITY_OPTIONS: Array<{ label: string; value: DisplayDensity }> = [
  { label: 'Compact', value: 'compact' },
  { label: 'Default', value: 'default' },
  { label: 'Roomy', value: 'roomy' },
];
